import React, { Suspense, lazy, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import "./Assets/Style/Spinner.css";

import Loader from "./Components/Misc/Loader";
import ScrollToTopButton from "./Components/CustomComponents/ScrollToTopBtn";
import SmoothScrollWrapper from "./Components/Misc/SmoothScroll";

const Router = lazy(() => import("./Components/Main/Router"));

function App() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [keywords, setKeywords] = useState("");
  const [robots, setRobots] = useState("");
  const [canonical, setCanonical] = useState("");
  const [geoData1, setgeoData1] = useState({});
  const [geoData2, setgeoData2] = useState({});

  useEffect(() => {
    fetch("https://msquaredtraining.com/metadata.json")
      .then((response) => response.json())
      .then((jsonData) => {
        setTitle(jsonData.title || "");
        setDescription(jsonData.description || "");
        setKeywords(jsonData.keywords || "");
        setRobots(jsonData.robots || "");
        setCanonical(jsonData.canonical || "");
        setgeoData1(jsonData.geoData1 || {});
        setgeoData2(jsonData.geoData2 || {});
      })
      .catch((error) => console.error("Error fetching the JSON data:", error));
  }, []);

  return (
    <SmoothScrollWrapper>
      <ToastContainer position="top-right" reverseOrder={false} />
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta name="keywords" content={keywords} />

          <meta name="geo.region" content={geoData1?.region} />
          <meta name="geo.placename" content={geoData1?.placename} />
          <meta name="geo.position" content={geoData1?.position} />
          <meta name="ICBM" content={geoData1?.ICBM} />

          <meta name="geo.region" content={geoData2?.region} />
          <meta name="geo.placename" content={geoData2?.placename} />
          <meta name="geo.position" content={geoData2?.position} />
          <meta name="ICBM" content={geoData2?.ICBM} />

          <meta name="robots" content={robots} />
          <link rel="canonical" href={canonical} />
        </Helmet>

        <Router />


        <ScrollToTopButton threshold={250} />
      </Suspense>
    </SmoothScrollWrapper>
  );
}

export default App;
